var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-header"},[(!_vm.isMobile)?_c('headerWeb'):_vm._e(),(_vm.isMobile && _vm.moveUp)?_c('headerMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }